import { render, staticRenderFns } from "./IconRecommendations.vue?vue&type=template&id=6444ab99&"
import script from "./IconRecommendations.vue?vue&type=script&lang=ts&"
export * from "./IconRecommendations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports